<template>
  <div class="userCenter">
     <job-header-simple header_title="连续劳务个税计算器"></job-header-simple>
    <section class="main-content">
        <div class="card">
            <p class="title">
                计算结果统计
            </p>
            <div class="card-content"> 
                <p>
                    税前收入: <span>{{ totalPreTaxAmount }}</span> 元
                </p>
                <p>
                    预扣个税: <span>{{ totalTaxAmount }}</span> 元
                </p>
                <p>
                   税后收入: <span>{{ totalAfterTaxAmount }}</span> 元
                </p>
            </div>
        </div>
          <div class="tax-month-fixed"  >
                <div class="header-top">
                   月份
                </div>
                <van-row class="tax-month" gutter="8">
                    <van-col span="8" v-for="item in filteredDataList" :key="item.month">
                       <span @click="checkMonth(item)"  class="month-item active">
                            {{item.month}}月
                            <img src="@/assets/images/del.png"  class="checkbox-img">
                       </span>
                    </van-col>
                </van-row>
                <van-button type="primary" class="js" block color="#326cf0" @click="submitForm">重新计算</van-button>
                <van-row class="tax-month-list-header" >
                    <van-col :span="item.clom" v-for="(item,index) in dataListResultHeader" :key="index+'resultHeader'">
                       {{ item.name }}
                    </van-col>
                </van-row>
                <van-row class="tax-month-list" >
                    <div v-for="(item,index) in dataListResult" :key="index+'result'">
                        <van-col span="3" >
                                     {{ item.month }}  
                        </van-col>
                         <van-col span="5" >
                                     {{ item.preTaxAmount }}   
                        </van-col>
                              <van-col span="6" >
                                     {{ item.taxAmount }}    
                        </van-col>
                         <van-col span="5" >
                                     {{ item.afterTaxAmount }}   
                        </van-col>
                         <van-col span="5" >
                                     {{ item.taxRate }}
                        </van-col>
                    </div>

                    
                </van-row>
                <p class="tip">
                    计算结果仅供参考
                </p>
                <van-divider>工蚁宝灵活用工平台</van-divider>
            </div>
    </section>
    
 
  </div>
</template>
<script>
import { Divider,CheckboxGroup,Checkbox,Field,Tabs,Tab,NavBar,Image, Cell, CellGroup, Button, Icon, Row, Col, Popup } from 'vant'
import { mapGetters } from 'vuex'
import jobHeaderSimple from "@/components/header/header.vue";
import { calculateTax } from '@/api/ocompany/request'
export default {
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popup.name]: Popup,
    jobHeaderSimple
  },
  data() {
    return {
        dataListResult:[],
        dataListResultHeader:[
            {
                name:"月份",
                clom:3,
            },
              {
                name:"税前(元)",
                clom:5,
            },
                {
                name:"预扣个税(元)",
                clom:6,
            },
              {
                name:"税后(元)",
                clom:5,
            },
               {
                name:"实际税负",
                clom:5,
            }
        ], 
        totalAfterTaxAmount:0,
        totalTaxAmount:0,
        totalPreTaxAmount:0,
        dataList:[ ]
    }
  },
    watch: {

    },
  computed: {
    ...mapGetters(['taxResult']),
      filteredDataList() {
      return this.dataList.filter(item => item.show);
    },
  },
  async created() {
     
    if (this.taxResult) {
        try {
            const parsedData = JSON.parse(this.taxResult);
            // 根据 monthlyData 构建 dataList
            if (parsedData.monthlyData && Array.isArray(parsedData.monthlyData)) {
                this.dataList = parsedData.monthlyData.map(item => ({
                    month: item.month,
                    amount: item.amount,
                    show: true // 添加 show 字段，默认为 true
                }));
            }
            this.submitForm();
        } catch (error) {
            console.error('解析 taxResult 数据失败:', error);
        }
    }
  },
  methods: {

    submitForm(){
        let data = this.dataList.filter(item => item.show);
        if(data.length>0){
            calculateTax(data).then((res) => {
                if (res.data.status == '200') {
                    let result = res.data.data;
                    this.totalAfterTaxAmount = result.totalAfterTaxAmount;
                    this.totalTaxAmount = result.totalTaxAmount;
                    this.totalPreTaxAmount = result.totalPreTaxAmount;
                    this.dataListResult = result.taxDetailList;
                }
            })
        }
    },
    //点击删除
    checkMonth(item){
        item.show=!item.show;
    }
  },
}
</script>

<style lang="less" scoped>

.userCenter {
    .tip{
        color: #999;
        font-size: 12px;
        text-align: center;
        margin-top: 12px;
    }
    /deep/.van-divider--content-center{
        color: #326cf0; 
        font-size: 14px;
    }
    /deep/.tax-month-list{
        font-family: SourceHanSansSC-Medium;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #333333;
        text-align: center;
    }
    /deep/.tax-month-list-header{
        font-family: SourceHanSansSC-Bold;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #326cf0;
        text-align: center;
        background-color: #e4eefe;
        border-radius: 6px 6px 0 0;
        margin-top: 12px;
    }
/deep/.js{
                font-family: SourceHanSansSC-Medium;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                border-radius: 6px;
    }
    .main-content{
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
    }
    .card{
        margin: 12px 0;
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        box-sizing: border-box;
        
        .title{
            font-family: SourceHanSansSC-Bold;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
            color: #222222;
        }
        .card-content{
          border-radius: 6px;
          border: solid 2px #e4eefe;
          margin-top: 12px;
          padding: 0 6px;
          p{
            font-family: SourceHanSansSC-Medium;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            color: #222222;
            span{
                color: #326cf0;
            }
          }
        }
    }
    .tax-month-fixed{
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        box-sizing: border-box;
        .header-top{
            font-family: SourceHanSansSC-Bold;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
        }

    }
     /deep/.tax-month{
           padding-top: 8px;
           padding-bottom: 8px;
           .month-item{
            display: block;
            width: 100%;
            height: 38px;
            line-height: 38px;
            text-align: center;
            font-family: SourceHanSansSC-Medium;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #222222;
            background-color: #fff;
            border-radius: 12px;
            border: solid 1px #c5dbff;
            margin-bottom: 12px;
            &.active{
                  background-color: #e4eefe;
                  position: relative;
            }
            .checkbox-img{
                position: absolute;
                right: -6px;
                top: -6px;
                width: 15px;
            }
           }
        }
}
</style>
